import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/x-button.png'


const _withScopeId = n => (_pushScopeId("data-v-ffb4b078"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "webview" }
const _hoisted_2 = { class: "x-button-container" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = {
  key: 0,
  class: "main-title"
}
const _hoisted_5 = { class: "sub-title" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = ["src"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "x-button",
        class: "x-button",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.onCloseWebview()))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.link), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.isReady)
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 0,
            src: _ctx.link,
            frameborder: "0"
          }, null, 8, _hoisted_7))
        : _createCommentVNode("", true)
    ])
  ]))
}